/* Feedogo: chat box at the bottom of the "Live Love" feed under the video (desktop).
   Viewers type a message there and it shows up in the Live Love feed, mixed in with the feedings, newest first.
   Messages go through the same live chat as "Community notes" (feedogo-live-chat.js → backend /api/comments), so
   everyone watching a feeder sees them, the one-message-per-minute limit applies, and admins hide unwanted ones in
   后台 → 内容管理 → 评论管理. The Live Love feed is hidden on phones and tablets (≤1024px), where the live chat already
   sits below the video, so this only shows on desktop. Like the other feedogo-*.js helpers it only adds a script to
   the feeder iframe and doesn't edit the big section file. */
(function () {
  'use strict';
  var FRAME_ID = 'feedogo-feeder-frame';
  var MARK = 'feedogo-ticker-chat';

  // Runs inside the feeder iframe.
  function tickerChat() {
    var C = window.LanglangCommunity, tk = document.querySelector('.live-ticker'), win = tk && tk.querySelector('.ticker-window');
    if (!C || !tk || !win || window.fgTickerChat) return;
    window.fgTickerChat = 1;
    var MAX = 120, WAIT = 60, LAST = 'fgChatLast', FORM_H = 64, timer = null, msgTimer = null, lastHTML = '';
    var EMOJI = ['❤️', '😻', '🐾', '😍', '👏', '🥰', '😂', '🌟'];
    var PLANE = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M3.4 20.4 21 12 3.4 3.6 3.4 10.2 15 12 3.4 13.8Z"/></svg>';
    var SMILE = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M8.5 14.5c.9 1.2 2.1 1.8 3.5 1.8s2.6-.6 3.5-1.8"/><circle cx="9" cy="10" r=".6" fill="currentColor"/><circle cx="15" cy="10" r=".6" fill="currentColor"/></svg>';

    var css = document.createElement('style');
    css.textContent =
      '.fg-tc-main{flex:1;min-width:0;display:flex;flex-direction:column}' +
      '.fg-tc-main .ticker-window{flex:none;align-self:stretch}' +
      'body[data-page="feed"] .live-ticker .fg-tc-main .ticker-window{height:calc(var(--rows,5)*var(--rowh,30px) - ' + FORM_H + 'px)!important}' +
      '.fg-tc-form{position:relative;height:' + FORM_H + 'px;flex:none;display:flex;align-items:center;gap:10px;padding:0 12px 0 14px;border-top:1px solid #dce8df;background:#fff}' +
      '.fg-tc-me{flex:none;display:grid;place-items:center;width:34px;height:34px;border-radius:50%;background:#e9f3e9;color:#123f34;font-size:13px;font-weight:900}' +
      '.fg-tc-box{flex:1;min-width:0;height:44px;display:flex;align-items:center;gap:4px;padding:0 6px 0 16px;border:1.5px solid #dce8df;border-radius:22px;background:#f6f9f6;transition:border-color .15s,box-shadow .15s,background .15s}' +
      '.fg-tc-box:focus-within{border-color:#7ea58f;background:#fff;box-shadow:0 0 0 4px rgba(126,165,143,.16)}' +
      '.fg-tc-box input{flex:1;min-width:0;height:100%;padding:0;border:0;background:none;color:#123f34;font:inherit;font-size:14.5px;outline:none}' +
      '.fg-tc-box input::placeholder{color:#8a9a91}' +
      '.fg-tc-count{flex:none;font-size:11px;font-weight:700;color:#8a9a91;font-variant-numeric:tabular-nums}' +
      '.fg-tc-count[hidden]{display:none}' +
      '.fg-tc-emo{flex:none;display:grid;place-items:center;width:34px;height:34px;padding:0;border:0;border-radius:50%;background:none;color:#52635a;cursor:pointer}' +
      '.fg-tc-emo:hover,.fg-tc-emo[aria-expanded="true"]{background:#e9f3e9;color:#123f34}' +
      '.fg-tc-send{flex:none;display:grid;place-items:center;width:44px;height:44px;padding:0;border:0;border-radius:50%;background:#d0573a;color:#fff;font:inherit;font-size:12px;font-weight:800;cursor:pointer;box-shadow:0 4px 12px rgba(208,87,58,.28);transition:transform .12s,background .15s}' +
      '.fg-tc-send:hover:not(:disabled){background:#bb4a2f;transform:translateY(-1px)}' +
      '.fg-tc-send:disabled{background:#c9d5ce;box-shadow:none;cursor:default}' +
      '.fg-tc-pick{position:absolute;right:62px;bottom:calc(100% + 8px);display:grid;grid-template-columns:repeat(4,38px);gap:4px;padding:8px;border:1px solid #dce8df;border-radius:14px;background:#fff;box-shadow:0 10px 28px rgba(18,63,52,.16);z-index:5}' +
      '.fg-tc-pick[hidden]{display:none}' +
      '.fg-tc-pick button{width:38px;height:38px;padding:0;border:0;border-radius:10px;background:none;font-size:21px;line-height:1;cursor:pointer}' +
      '.fg-tc-pick button:hover{background:#f0f6f1}' +
      '.fg-tc-msg{position:absolute;left:14px;right:12px;bottom:calc(100% + 8px);padding:7px 12px;border-radius:10px;background:#123f34;color:#fff;font-size:12px;line-height:1.35;white-space:normal;pointer-events:none;z-index:6}' +
      '.fg-tc-msg[hidden]{display:none}' +
      '.ticker-event.fg-tchat .ticker-avatar{background:#fdeee8;color:#c4552f;border-color:#f3d3c6}' +
      '.ticker-event.fg-tchat b{color:#c4552f}' +
      '.ticker-event.fg-tchat .fg-tc-text{color:#123f34}' +
      '.ticker-event.fg-tchat .fg-tc-time{color:#7b8c82}';
    document.head.appendChild(css);

    var main = document.createElement('div');
    main.className = 'fg-tc-main';
    tk.insertBefore(main, win);
    main.appendChild(win);
    var form = document.createElement('form');
    form.className = 'fg-tc-form';
    form.setAttribute('autocomplete', 'off');
    form.innerHTML = '<span class="fg-tc-me" aria-hidden="true"></span>' +
      '<div class="fg-tc-box"><input type="text" maxlength="' + MAX + '" placeholder="Say something nice to everyone watching…" aria-label="Chat message">' +
      '<span class="fg-tc-count" hidden></span><button type="button" class="fg-tc-emo" aria-label="Add an emoji" aria-expanded="false">' + SMILE + '</button></div>' +
      '<button type="submit" class="fg-tc-send" aria-label="Send message">' + PLANE + '</button>' +
      '<div class="fg-tc-pick" hidden>' + EMOJI.map(function (e) { return '<button type="button">' + e + '</button>'; }).join('') + '</div>' +
      '<span class="fg-tc-msg" role="status" aria-live="polite" hidden></span>';
    main.appendChild(form);
    var input = form.querySelector('input'), btn = form.querySelector('.fg-tc-send'), msg = form.querySelector('.fg-tc-msg');
    var count = form.querySelector('.fg-tc-count'), emo = form.querySelector('.fg-tc-emo'), pick = form.querySelector('.fg-tc-pick');
    function me() {
      var cust = window.feedogoCustomer || {}, nick = '';
      try { nick = ((document.getElementById('commentNickname') || {}).value || '').trim(); } catch (e) {}
      form.querySelector('.fg-tc-me').textContent = (nick || (cust.loggedIn && cust.first) || 'You').slice(0, nick || cust.first ? 1 : 3);
    }
    function counter() {
      var n = input.value.length;
      count.hidden = n < MAX - 30;
      count.textContent = (MAX - n) + '';
    }
    input.addEventListener('input', counter);
    emo.addEventListener('click', function () {
      pick.hidden = !pick.hidden;
      emo.setAttribute('aria-expanded', String(!pick.hidden));
    });
    pick.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var at = input.selectionStart == null ? input.value.length : input.selectionStart, v = input.value, add = b.textContent;
      if (v.length + add.length > MAX) return;
      input.value = v.slice(0, at) + add + v.slice(input.selectionEnd == null ? at : input.selectionEnd);
      input.focus();
      input.setSelectionRange(at + add.length, at + add.length);
      counter();
    });
    document.addEventListener('click', function (e) {
      if (!pick.hidden && !pick.contains(e.target) && !emo.contains(e.target)) { pick.hidden = true; emo.setAttribute('aria-expanded', 'false'); }
    });
    me();
    var nickBox = document.getElementById('commentNickname');
    if (nickBox) nickBox.addEventListener('input', me);

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    }
    function clock(ts) {
      try { if (typeof fmtClock === 'function') return fmtClock({ ts: ts }); } catch (e) {}
      return new Date(ts).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    }
    function say(text) {
      clearTimeout(msgTimer);
      msg.textContent = text;
      msg.hidden = !text;
      if (text) msgTimer = setTimeout(function () { msg.hidden = true; }, 5000);
    }
    function left() {
      var last = 0;
      try { last = +localStorage.getItem(LAST) || 0; } catch (e) {}
      return Math.max(0, Math.ceil(WAIT - (Date.now() - last) / 1000));
    }
    function countdown() {
      clearInterval(timer);
      function step() {
        var s = left();
        btn.disabled = s > 0;
        btn.innerHTML = s > 0 ? s + 's' : PLANE;
        btn.setAttribute('aria-label', s > 0 ? 'You can send again in ' + s + ' seconds' : 'Send message');
        if (!s) clearInterval(timer);
      }
      step();
      if (left() > 0) timer = setInterval(step, 1000);
    }
    function chats(code) {
      var list = [];
      try { list = C.list(code) || []; } catch (e) {}
      return list.filter(function (m) { return m && !m.demo && m.text; }).slice(0, 12);
    }
    function chatMarkup(m) {
      var who = String(m.author || 'Guest'), time = clock(m.createdAt || Date.now());
      return '<span class="ticker-event fg-tchat" title="' + esc(who + ': ' + m.text) + '"><span class="ticker-avatar">' + esc(who.slice(0, 1).toUpperCase()) +
        '</span><span><b>' + esc(who) + '</b> <span class="fg-tc-text">' + esc(m.text) + '</span> <span class="fg-tc-time">\u00b7 ' + esc(time) + '</span></span></span>';
    }

    // Live Love rows: feedings and chat messages together, newest first. Replaces the page's drawTickerRows; the page's
    // scroll loop keeps scrolling the track whenever data-fg-loop is 1.
    window.drawTickerRows = function () {
      var track = document.getElementById('tickerTrack');
      if (!track) return;
      var st = window.currentStation, events = [];
      try { events = (state.liveEvents || []).slice(0, 12); } catch (e) {}
      var rows = events.map(function (e) {
        var html = '';
        try { html = tickerMarkup(e); } catch (x) { html = '<span class="ticker-event"><span><b>' + esc(e.user) + '</b> ' + esc(e.action) + '</span></span>'; }
        return { ts: e.ts || 0, html: html };
      }).concat(chats(st && st.code).map(function (m) { return { ts: m.createdAt || 0, html: chatMarkup(m) }; }));
      rows.sort(function (a, b) { return b.ts - a.ts; });
      rows = rows.slice(0, 18);
      var html = rows.map(function (r) { return r.html; }).join(''), key = win.clientHeight + '|' + html;
      if (key === lastHTML && track.innerHTML) return;
      lastHTML = key;
      track.style.transition = 'none';
      track.classList.remove('sliding');
      if (!rows.length) { track.textContent = 'No feeding activity yet. Say hello below!'; track.dataset.fgLoop = '0'; track.style.transform = ''; return; }
      track.innerHTML = html;
      // scroll only when the rows don't fit in the window
      if (track.scrollHeight > win.clientHeight + 2) { track.innerHTML = html + html; track.dataset.fgLoop = '1'; }
      else { track.dataset.fgLoop = '0'; track.style.transform = ''; }
    };
    // newest message at the top again (renderTicker resets the scroll position, then redraws)
    function restart() { lastHTML = ''; try { window.renderTicker(); } catch (e) { window.drawTickerRows(); } }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var st = window.currentStation, text = input.value.trim();
      if (!st || !st.code) return say('Pick a feeder first.');
      if (!text) return input.focus();
      var wait = left();
      if (wait > 0) return say('One message a minute, please. You can send again in ' + wait + 's.');
      var nick = '', cust = window.feedogoCustomer || {};
      try { nick = (document.getElementById('commentNickname') || {}).value || ''; } catch (x) {}
      try {
        C.add(st, nick.trim() || (cust.loggedIn && (cust.name || cust.first)) || '', text);
      } catch (err) {
        return say(err && err.message ? err.message : 'Your message was not sent. Please try again.');
      }
      input.value = '';
      counter();
      pick.hidden = true;
      emo.setAttribute('aria-expanded', 'false');
      say('');
      window.dispatchEvent(new Event('langlang-comments-changed'));
      restart();
      countdown();
    });

    window.addEventListener('langlang-comments-changed', function () { window.drawTickerRows(); setTimeout(countdown, 0); });
    // a failed send shows its reason under the Community notes form; repeat it here
    var fb = document.getElementById('commentFeedback');
    if (fb) new MutationObserver(function () { if (fb.textContent && document.activeElement === input) say(fb.textContent); }).observe(fb, { childList: true, characterData: true, subtree: true });
    restart();
    countdown();
  }

  function tick() {
    try {
      var f = document.getElementById(FRAME_ID);
      var w = f && f.contentWindow, d = w && w.document;
      // wait for the live chat helper so messages go to the shared chat, not just this browser
      if (!d || !d.body || !w.LanglangCommunity || !w.LanglangCommunity.fgLive || typeof w.renderTicker !== 'function' ||
          !d.getElementById('tickerTrack') || d.getElementById(MARK)) return;
      var s = d.createElement('script');
      s.id = MARK;
      s.textContent = '(' + tickerChat.toString() + ')();';
      d.body.appendChild(s);
    } catch (e) {}
  }

  setInterval(tick, 300);
})();
